<template>
    <div class="loading-wrap">
        <div class="loading" v-if="loading">
            <div class="loading-img"></div>
            <p>加载中...</p>
        </div>
        <div class="loading" v-if="!loading">
            <div class="loading-img-error"></div>
            <p v-if="(!list && resultCode != '99999')" class="loading-text">暂无数据</p>
            <p v-if="(list && resultCode != '99999')" class="loading-text" @click="reload()">
                加载失败<br/>
                <i>点击页面重新加载</i>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "loading",
        props: ['list', 'loading', 'resultCode'],
        data (){
            return {}
        },
        methods: {
            reload: function () {
                window.location.reload()
            },
            touchHandle: function (e) {
                e.preventDefault()
            }
        },
        destroyed: function () {
            let self = this
            window.removeEventListener('touch', self.touchHandle)
            document.documentElement.classList.remove('noscroll')
        },
        created: function () {
            let self = this
            window.addEventListener('touch', self.touchHandle, false)
            document.documentElement.classList.add('noscroll')
        }
    }
</script>

<style lang="scss" scoped>
    .loading-wrap {
        text-align: center;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        background: #fff;
        overflow: hidden;
        .loading{
            position: absolute;
            left: 0;
            right: 0;
            top: 50%;
            display: inline-block;
            margin: 0 auto;
            width: 3.2rem;
            transform: translateY(-50%);
            &-img{
                background: url("../../assets/images/common/loading-logo.gif") 0 0/1.56rem 1.54rem no-repeat;
                width: 1.56rem;
                height: 1.54rem;
                margin: 0 auto;
            }
            &-img-error{
                background: url("../../assets/images/common/loading-fail.png") 0 0/1.68rem 1.48rem no-repeat;
                width: 1.68rem;
                height: 1.48rem;
                margin: 0 auto;
            }
            p{
                text-align: center;
                font-size: 0.32rem;
                color: #8487a0;
                margin-top: 0.2rem;
                i{
                    font-size: .24rem;
                    color: #8487a0;
                }
            }
        }
    }
    .loading-text {
        text-align: center;
        font-size: 0.32rem;
        color: #8487a0;
    }
</style>